import type { Transition } from "@uirouter/react";

export const onRedirectQueryFilter = (transition: Transition) => {
    const toParams = transition.params();
    const fromParams = transition.params("from");
    const fromState = transition.from().name;
    const toState = transition.to().name;
    if (toState !== fromState && toParams.hasOwnProperty("key") !== fromParams.hasOwnProperty("key")) {
        return toParams.multiIncludeExcludeUrl
            ? { params: { ...toParams, multiIncludeExcludeUrl: undefined } }
            : undefined;
    }
};
